import { render, staticRenderFns } from "./CorrectList.vue?vue&type=template&id=f2a7d170&scoped=true&"
import script from "./CorrectList.vue?vue&type=script&lang=ts&"
export * from "./CorrectList.vue?vue&type=script&lang=ts&"
import style0 from "./CorrectList.vue?vue&type=style&index=0&id=f2a7d170&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a7d170",
  null
  
)

export default component.exports